import { useInvoiceEditorForm } from '../../../../../../../../../../../../../../contexts/invoiceEditorFormContext'
import { CurrencyInput } from '../../../../../../../../../CurrencyInput'
import { CommonInvoiceLineFieldProps } from '../../../../../../types/commonInvoiceLineFieldProps'

interface InvoiceSubtotalIncludingVatProps extends CommonInvoiceLineFieldProps {
  columnIndex: number
}

export const InvoiceSubtotalIncludingVat = ({
  disabled = false,
  lineIndex,
  columnIndex,
}: InvoiceSubtotalIncludingVatProps) => {
  const { invoiceEditorForm } = useInvoiceEditorForm()
  const { FormItem } = invoiceEditorForm
  const columnPlacementIndex = columnIndex + 1

  return (
    <FormItem
      itemColumnStart={columnPlacementIndex}
      name={`invoiceLines.${lineIndex}.subtotalIncludingVat`}
      render={({ field: { value, onChange, ...props } }) => {
        return <CurrencyInput {...props} disabled={disabled} onChange={onChange} readOnly value={value} />
      }}
    />
  )
}
